import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  disabledInputValue: {
    '& > .Mui-disabled': {
      fontWeight: 600,
    },
  },
  giftInformationItem: {
    padding: theme.spacing(15, 12),
    border: '1px solid #ABAFB3',
    borderRadius: theme.spacing(7.5),
  },
}));
